// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3slln","footer":"Form_footer__2L5TO"};